export default "__VITE_PUBLIC_ASSET__3d9c23d8__"